import _ from 'lodash';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UploadStates } from 'constants/index';

export interface Audience {
  id?: string;
  name?: string;
  groupId?: number;
  totalSize?: number;
  size?: number;
  status?: UploadStates;
  createdAt?: number;
  updatedAt?: number;
  totalcount?: number;
  lal_model_type: string;
  inHouseModelingStatus?: any;
  lalAudienceCount?: any;
}

export interface UpdateAudienceSizeAndStatusPayload {
  size?: number;
  status: UploadStates;
  /** Unified audience id (`uni_…`); must match currentAudience.id */
  audienceId?: string | number;
}

export interface AudienceGroup {
  updated_at: any;
  id: string;
  name: string;
  audiences: Audience['id'][];
}

interface AudienceState {
  currentAudience?: Audience;
  ui: {
    audienceLoading: LoadingProps;
    audienceSaving: LoadingProps;
    notifications: Array<LoadingProps>;
  };
}

const initialState: AudienceState = {
  ui: {
    audienceLoading: { state: 'idle' },
    audienceSaving: { state: 'idle' },
    notifications: [],
  },
};

export const audienceSlice = createSlice({
  name: 'audience',
  initialState,
  reducers: {
    addAudience: (state, action: PayloadAction<Audience>) => {
      state.currentAudience = action.payload;
    },
    clearCurrentCustomAudience: (state) => {
      state.currentAudience = undefined;
    },
    exportAudience: () => {
      // Skeleton to get helpers to build actions
      // Refer saga.ts
    },
    saveCustomAudience: () => {
      // skeleton
    },
    updateCurrentCustomAudience: (state, action: PayloadAction<Audience>) => {
      state.currentAudience = action.payload;
    },
    fetchCustomAudience: (state, action: PayloadAction<Audience>) => {
      // skeleton
    },
    setAudienceLoadingState: (state, action: PayloadAction<LoadingProps>) => {
      state.ui.audienceLoading = action.payload;
    },
    addNotification: (state, action: PayloadAction<LoadingProps>) => {
      state.ui.notifications.push(action.payload);
    },
    updateAudienceSizeAndStatus: (
      state,
      action: PayloadAction<UpdateAudienceSizeAndStatusPayload>
    ) => {
      if (!state.currentAudience) {
        return;
      }

      // Fail closed: missing unified id → no write (INT-161).
      // audienceId is uni_… (same space as URL / currentAudience.id).
      const payloadAudienceId = action.payload.audienceId;
      if (
        payloadAudienceId == null ||
        payloadAudienceId === '' ||
        String(state.currentAudience.id) !== String(payloadAudienceId)
      ) {
        return;
      }

      state.currentAudience.size = action.payload.size || 0;
      state.currentAudience.status = action.payload.status;
    },
  },
});

export const {
  addAudience,
  clearCurrentCustomAudience,
  exportAudience,
  fetchCustomAudience,
  saveCustomAudience,
  setAudienceLoadingState,
  updateCurrentCustomAudience,
  addNotification,
  updateAudienceSizeAndStatus,
} = audienceSlice.actions;

export default audienceSlice.reducer;
